import React, { useState } from 'react';
import { AlertCircleIcon, CheckIcon, Loader2Icon } from 'lucide-react';
import { Button } from '../ui/Button';
import { TextField } from '../ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import type { PasswordChangeResult } from '../../contexts/AdminDataContext';
const errorMessages: Record<Exclude<PasswordChangeResult, 'ok'>, string> = {
  'wrong-current': 'Den nuværende adgangskode er forkert.',
  mismatch: 'De to nye adgangskoder er ikke ens.',
  'too-short': 'Den nye adgangskode skal være mindst 8 tegn.',
  'save-failed': 'Adgangskoden kunne ikke gemmes. Tjek at browseren tillader lagring.'
};
export function SecuritySection() {
  const {
    changePassword
  } = useAdminData();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [working, setWorking] = useState(false);
  const [result, setResult] = useState<PasswordChangeResult | null>(null);
  return <section className="mt-8 max-w-2xl rounded-card border border-line bg-white p-6" data-id="element-52" data-mp="dzqhm7yxtcuw">
      <h2 className="font-display text-lg font-bold tracking-tight text-ink" data-id="element-53" data-mp="99a28ibk3h5w">Sikkerhed</h2>
      <p className="mt-2 text-sm text-ink-soft" data-id="element-54" data-mp="97gvz44uuyyf">
        Skift adgangskoden til admin. Adgangskoden gemmes krypteret (hash), aldrig som læsbar tekst.
      </p>

      <form className="mt-5" onSubmit={async event => {
      event.preventDefault();
      if (working) return;
      setWorking(true);
      const outcome = await changePassword(current, next, confirm);
      setResult(outcome);
      if (outcome === 'ok') {
        setCurrent('');
        setNext('');
        setConfirm('');
      }
      setWorking(false);
    }} data-id="element-55" data-mp="a6hl9wqqtpa">
        <div className="grid gap-5" data-id="element-56" data-mp="j1fp5dmyb8e8">
          <TextField id="sec-nuvaerende" label="Nuværende adgangskode" type="password" required autoComplete="current-password" value={current} error={result === 'wrong-current' ? errorMessages['wrong-current'] : undefined} onChange={event => {
          setCurrent(event.target.value);
          setResult(null);
        }} data-id="element-57" data-mp="38oosrkhzapd4" />
          <div className="grid gap-5 sm:grid-cols-2" data-id="element-58" data-mp="2w7vwk2ypl5ki">
            <TextField id="sec-ny" label="Ny adgangskode" type="password" required autoComplete="new-password" hint="Mindst 8 tegn." value={next} error={result === 'too-short' ? errorMessages['too-short'] : undefined} onChange={event => {
            setNext(event.target.value);
            setResult(null);
          }} data-id="element-59" data-mp="306msw7vcoj6k" />
            <TextField id="sec-bekraeft" label="Bekræft ny adgangskode" type="password" required autoComplete="new-password" value={confirm} error={result === 'mismatch' ? errorMessages.mismatch : undefined} onChange={event => {
            setConfirm(event.target.value);
            setResult(null);
          }} data-id="element-60" data-mp="23hdvf7hjpe9q" />
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-4" data-id="element-61" data-mp="1xss99eo4krk2">
          <Button type="submit" disabled={working || !current || !next || !confirm} data-id="element-62" data-mp="1tryk6hyy56pl">
            {working ? <>
                <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-63" data-mp="27qy8foijrjl8" />
                Skifter …
              </> : 'Skift adgangskode'}
          </Button>

          {result === 'ok' && <p role="status" className="flex items-center gap-2 text-[15px] text-ink" data-id="element-64" data-mp="2cl2fs8vq5tmu">
              <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-accent-soft text-accent-deep" data-id="element-65" data-mp="2qj92qtz4y97q">
                <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-66" data-mp="2lm0jeq293z4w" />
              </span>
              Adgangskoden er blevet ændret
            </p>}

          {result && result !== 'ok' && <p role="alert" className="flex items-start gap-2 text-[15px] text-danger" data-id="element-67" data-mp="ot1yg4j96use">
              <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-68" data-mp="tmmnh72vcefg" />
              {errorMessages[result]}
            </p>}
        </div>
      </form>
    </section>;
}